/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ muscle: NonNullable<unknown> }} Prescription_Reason_Goal_CompoundInputs */

const en_us2_prescription_reason_goal_compound = /** @type {(inputs: Prescription_Reason_Goal_CompoundInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A compound lift for ${i?.muscle}: more muscle per set`)
};

const pt_br2_prescription_reason_goal_compound = /** @type {(inputs: Prescription_Reason_Goal_CompoundInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Composto para ${i?.muscle}: mais músculo por série`)
};

const es_419_prescription_reason_goal_compound = /** @type {(inputs: Prescription_Reason_Goal_CompoundInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Un compuesto para ${i?.muscle}: más músculo por serie`)
};

const pt_pt2_prescription_reason_goal_compound = /** @type {(inputs: Prescription_Reason_Goal_CompoundInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Composto para ${i?.muscle}: mais músculo por série`)
};

const fr_fr2_prescription_reason_goal_compound = /** @type {(inputs: Prescription_Reason_Goal_CompoundInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Un polyarticulaire pour ${i?.muscle} : plus de muscle par série`)
};

const de_de2_prescription_reason_goal_compound = /** @type {(inputs: Prescription_Reason_Goal_CompoundInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Eine Grundübung für ${i?.muscle}: mehr Muskel pro Satz`)
};

const it_it2_prescription_reason_goal_compound = /** @type {(inputs: Prescription_Reason_Goal_CompoundInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Un multiarticolare per ${i?.muscle}: più muscolo per serie`)
};

/**
* | output |
* | --- |
* | "A compound lift for {muscle}: more muscle per set" |
*
* @param {Prescription_Reason_Goal_CompoundInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const prescription_reason_goal_compound = /** @type {((inputs: Prescription_Reason_Goal_CompoundInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prescription_Reason_Goal_CompoundInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_prescription_reason_goal_compound(inputs)
	if (locale === "es-419") return es_419_prescription_reason_goal_compound(inputs)
	if (locale === "pt-PT") return pt_pt2_prescription_reason_goal_compound(inputs)
	if (locale === "fr-FR") return fr_fr2_prescription_reason_goal_compound(inputs)
	if (locale === "de-DE") return de_de2_prescription_reason_goal_compound(inputs)
	if (locale === "it-IT") return it_it2_prescription_reason_goal_compound(inputs)
	return en_us2_prescription_reason_goal_compound(inputs)
});
export { prescription_reason_goal_compound as "prescription.reason.goal_compound" }